module.exports = "/_next/static/images/a6019db31895e71ee657e02bd0365208-hands-holding-cards-lg@3x.jpg";